import { render, staticRenderFns } from "./WriteNote.vue?vue&type=template&id=05d60ac6&"
import script from "./WriteNote.vue?vue&type=script&lang=js&"
export * from "./WriteNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports